import '.ag{max-width:77.5rem;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.fh{justify-content:stretch;}.ssr-plugin'
import '.b0{position:sticky;}.ssr-plugin'
import '.b1{top:0px;}.ssr-plugin'
import '.b5{z-index:10;}.ssr-plugin'
import '.ga{background:var(--palette-beige-100);}.ssr-plugin'
import '.gb{padding-block:1.5rem;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.c0{flex-wrap:wrap;}.ssr-plugin'
import '.h{flex:1 0 0;}.ssr-plugin'
import { Style, styled } from 'inlines'
import fullLogo from '@app/assets/fullLogo.svg'
import { useLanguage } from '@i18n/useLanguage'
import { i18n } from '@i18n/index'
import { TextLink } from '@app/components/core/link/TextLink'
import {
  faEnvelope,
  faHouse,
  faLightbulb,
} from '@fortawesome/pro-solid-svg-icons'
import Row from '@app/components/layout/Row'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { fullName } from '@app/util/helpers'
import { useLocation } from 'wouter'
import { pages } from '@app/util/links'
import { NavBarItem } from './blocks/NavBarItem'
import { NavBarMenuIcon } from './blocks/NavBarMenuIcon'
import { ProfileMenu } from '../blocks/ProfileMenu'
import useMediaQuery from '@app/util/useMediaQuery'
import { useUserContext } from '@app/util/hooks/useUserContext'

const ACCOUNT_APPEAR_ANIMATION = 'nav-account-appear 220ms ease-out'

export const DashboardNavBar = ({
  initiativeDashboard,
  style,
}: {
  initiativeDashboard?: boolean
  style?: Style
}) => {
  const isMobile = useMediaQuery()
  const [language, _] = useLanguage()
  const translations = i18n.languages[language].app.dashboard.nav
  const [location, navigate] = useLocation()

  const { user, isLoading } = useUserContext()
  const firstName = user?.firstName ?? ''
  const name = user ? fullName(user) : ''

  return (
    <styled.div className="ag d e fh b0 b1 b5 ga"
      style={{
        width: isMobile ? '100%' : '85%',
        paddingInline: isMobile ? '1rem' : 0,
        ...style,
      }}
    >
      <nav className="gb d r c0"
        style={{
          justifyContent: initiativeDashboard ? 'end' : 'space-between',}}
      >
        {!initiativeDashboard && (
          <TextLink to={pages.home} noHover={true} isBold={false}>
            <img src={fullLogo} alt="Crowdbuilding Logo" />
          </TextLink>
        )}
        <Row
          gap={isMobile ? '3rem' : '3.5rem'}
          style={{ flexGrow: isMobile ? 1 : 0 }}
        >
          <NavBarMenuIcon
            icon={faHouse}
            label={translations.home}
            toggled={location === pages.dashboard}
            onClick={() => navigate(pages.dashboard)}
          />
          <NavBarMenuIcon
            icon={faEnvelope}
            label={translations.messages}
            toggled={location.startsWith(pages.dashboardMessages)}
            onClick={() => navigate(pages.dashboardMessages)}
          />
          <NavBarMenuIcon
            icon={faLightbulb}
            label={translations.initiatives}
            toggled={
              location === pages.dashboardInitiatives || initiativeDashboard
            }
            onClick={() => navigate(pages.dashboardInitiatives)}
          />
          <div className="h"
            style={{
              animation: isLoading ? undefined : ACCOUNT_APPEAR_ANIMATION,
            }}
          >
            <ProfileMenu>
              <NavBarItem label={firstName} toggled={false}>
                <Avatar
                  size="extra-small"
                  labelSource={name}
                  image={user?.avatar?.src}
                />
              </NavBarItem>
            </ProfileMenu>
          </div>
        </Row>
      </nav>
    </styled.div>
  )
}
